import { QueryCacheProviderOptions } from '@packages/shared/core/queryCache/entities';
import { useCachedQuery } from '@packages/shared/core/queryCache/hooks';
import { SuggestedLocation } from '../entities';

type useSuggestedLocationsQueryParams = {
  key: string | null;
  location?: string;
  options?: QueryCacheProviderOptions<Array<SuggestedLocation>>;
};

export const useSuggestedLocationsQuery = ({ key, location, options }: useSuggestedLocationsQueryParams) => {
  const {
    data = [],
    isLoading,
    isValidating,
    error,
  } = useCachedQuery(
    key,
    ({ services }) => {
      const { geoService } = services;

      return () => geoService.getSuggestedLocations(location || '');
    },
    options,
  );

  return {
    data,
    isLoading: isLoading || isValidating,
    error: error?.message || '',
  };
};
